import { EtaContent, EtaType } from '@/types';

export const etaContent: EtaContent[] = [
  {
    type: EtaType.donorOR,
    label: 'Donor OR',
  },
  {
    type: EtaType.txCenterSta,
    label: 'Organ STA',
  },
  {
    type: EtaType.txCenterOr,
    label: 'TX Center OR',
  },
  {
    type: EtaType.delay,
    label: 'Delay',
  },
];
